module.exports = __webpack_public_path__ + "static/fujistyle-8c3122498a7a38c3ca6c7a26a2e207bb.png";